export default `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 1024 1024">
    <path d="M136.534 341.333l-136.534 273.066v-409.6h136.534q0-27.99 20.138-48.128t48.128-20.138h204.8q27.99 0 48.128 20.138t20.138 48.128h341.334v136.534h-682.666zM1024 409.6l-204.8 477.866h-819.2l204.8-477.866h819.2z"></path>
</svg>
`;
